import Constants from '../../constants/Constants';
import Helpers from '../../helpers/Helpers';

export const getUserAlerts = (nextRowKey = null) => {
  let query = {
    nextRowKey: nextRowKey ? nextRowKey : null,
  };

  return Helpers.get(`${Constants.USER_ALERTS_URL}`, {}, query);
};

export const getUserAlertsNumber = () => {
  return Helpers.get(`${Constants.USER_ALERTS_URL}/number`);
};

export const acknowledgeAllUserAlerts = () => {
  return Helpers.post(`${Constants.USER_ALERTS_URL}/acknowledgeall`);
};

export const acknowledgeUserAlerts = (serialNumber, referenceDate, alertType) => {
  let query = {
    serialNumber: serialNumber,
    referenceDate: referenceDate,
    alertType: alertType,
  };
  return Helpers.get(`${Constants.USER_ALERTS_URL}/acknowledge`, {}, query);
};
